import { SIGN_IN, CHANGE_PASSWORD, CARD_EXPIRY_DETAILS, USER_INFO_DETAILS } from '../../actions/action_types';

const INTIAL_STATE = {
  isSignedIn: null,
  userId: null,
  cardExpiryDetails: { buyerCardExpired: false, sellerCardExpired: false, subscriptionCardExpired: false },
  latestTermsAndCondition: undefined,
  latestTermsAndConditionAcknowledgedDetails: undefined,
  betaUsersList: undefined
}
export default (state = INTIAL_STATE, action) => {
  if (state === undefined) {
    state = null;
  }
  switch (action.type) {
    case SIGN_IN:
      return { ...state, isSignedIn: true, userId: action.payload };
    case CHANGE_PASSWORD:
      return { ...state, isSignedIn: false, userId: null };
    case CARD_EXPIRY_DETAILS:
      return { ...state, cardExpiryDetails: { buyerCardExpired: action.payload1, sellerCardExpired: action.payload2, subscriptionCardExpired: action.payload3 } };
    case 'STORE_TERMS_AND_CONDITIONS':
      return { ...state, latestTermsAndCondition: action.payload1 };
    case 'STORE_TERMS_AND_CONDITIONS_ACKNOWLEDGE_DETAILS':
      return { ...state, latestTermsAndConditionAcknowledgedDetails: action.payload1 };
    case 'STORE_BETA_USERS_LIST':
      return { ...state, betaUsersList: action.payload1 };
    default:
      return state;
  }
};
